import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion";

export default function CTASection({
  kicker = "Let's Talk",
  title = "Ready to grow your business — globally or digitally?",
  subtitle = "One conversation is all it takes to find your next step. No obligation, no jargon — just honest, experienced advice.",
  ctaLabel = "Book a Free Consultation",
  ctaTo = "/contact",
  accent = "gold",
}) {
  const glow =
    accent === "teal"
      ? "bg-[radial-gradient(ellipse_at_center,rgba(0,180,216,0.12),transparent_65%)]"
      : "bg-[radial-gradient(ellipse_at_center,rgba(201,162,39,0.1),transparent_65%)]";

  return (
    <section className="relative overflow-hidden py-28 md:py-36" data-testid="cta-section">
      <div className={`absolute inset-0 ${glow}`} />
      <div className="relative mx-auto max-w-4xl px-6 text-center">
        <Reveal>
          <p className={`kicker mb-6 ${accent === "teal" ? "text-teal" : "text-gold"}`}>{kicker}</p>
          <h2 className="font-serif text-4xl leading-[1.1] tracking-tight text-white md:text-6xl">{title}</h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-400 md:text-lg">{subtitle}</p>
          <div className="mt-10">
            <Link to={ctaTo} data-testid="cta-section-button" className={accent === "teal" ? "btn-secondary" : "btn-primary"}>
              {ctaLabel} <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
